$(document).on('click', '.category-select', function(){
    $(this).siblings( '.list-bl' ).toggleClass('active');
})
